/**
 * Sharing one tasting with friends (founder decision of 2026-10-25) -- pure rules, no I/O. A share
 * is an explicit act per tasting: the wine's name, a place on the five-point scale and a line the
 * person typed or picked themselves. It never carries note text, descriptors or the free-text
 * note, so there is nothing here that could be filled in from a private note.
 */
import type { Quality } from "../scales.js";
import { LIVE_VERDICTS } from "./liveTasting.js";

/** A shared tasting stays in friends' feeds this long, counted from the share. */
export const TASTING_SHARE_RETENTION_DAYS = 90;

/** The places on the scale a share can name: the whole scale but a fault. */
export const SHARE_BANDS = LIVE_VERDICTS;
export type ShareBand = (typeof SHARE_BANDS)[number];

/** The band of a verdict, or none for a faulty bottle, which is not something to recommend. */
export function shareBandOf(quality: Quality): ShareBand | undefined {
  return SHARE_BANDS.find((band) => band === quality);
}

/** A catalogue wine's identity id: the only kind other people have a page for. */
export const SHARE_WINE_REF = /^druif:\d+$/;

/** The wine id a share may carry; a hand-entered wine has no page for anyone else, so it has none. */
export function shareWineRef(wineId: string): string | undefined {
  return SHARE_WINE_REF.test(wineId) ? wineId : undefined;
}

/** What the feed calls the wine: "Barolo 2019", without saying the year twice. */
export function shareWineTitle(name: string, vintage: number | null | undefined): string {
  if (vintage === null || vintage === undefined) return name;
  return name.trim().endsWith(String(vintage)) ? name : `${name} ${String(vintage)}`;
}
